import {
  TileDropdownButton,
  TileHyperLink,
  TileIconButton,
  TileNote,
  TileStandardButton, TileTextDropdownButton,
  TileToggleButton
} from './TileTypes';
import {TextButton, IconButton} from '../Button';
import {ToggleButton} from '../Toggles';
import {DropdownButton} from '../Dropdown';
import React from 'react';
import styled from 'styled-components';
import {
  COLORS, ComponentLStyling,
  ComponentMStyling,
  ComponentSStyling,
  ComponentTextStyle,
  ComponentXSStyling,
  ComponentXXSStyling
} from '../styles';
import {HyperLink} from '../HyperLink';
import {Size} from '../types';


export const TileNoteText = styled.div``;
export const TileNoteIcon = styled.div`display: flex;`;
export const TileNoteWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${props => COLORS.generateToken({componentType:'text',defaultVariant:'subtle'}, props.theme)};

  &.small {
    gap: 4px;

    ${TileNoteIcon} {
      width: 16px;
      height: 16px;
    }

    ${TileNoteText} {
      ${ComponentXXSStyling(ComponentTextStyle.Regular, null)}
    }
  }

  &.medium {
    gap: 6px;

    ${TileNoteIcon} {
      width: 16px;
      height: 16px;
    }

    ${TileNoteText} {
      ${ComponentXSStyling(ComponentTextStyle.Regular, null)}
    }

  }

  &.large {
    gap: 8px;

    ${TileNoteIcon} {
      width: 20px;
      height: 20px;
    }

    ${TileNoteText} {
      ${ComponentSStyling(ComponentTextStyle.Regular, null)}
    }
  }
`;


export const TileHyperLinkIcon = styled.div`display: flex`;
export const TileHyperLinkText = styled.div``;

export const TileHyperLinkWrapper = styled.div`
  width: max-content;

  ${props => ComponentSStyling(ComponentTextStyle.Bold, COLORS.generateToken({componentType:'text-link', defaultVariant: 'primary' }, props.theme))}
  a {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }

  &.small {
    ${TileHyperLinkIcon} {
      width: 24px;
      height: 24px;
    }

    ${TileHyperLinkText} {
      ${ComponentSStyling(ComponentTextStyle.Bold, null)}
    }

    a {
      gap: 4px;
    }
  }

  &.medium {
    ${TileHyperLinkIcon} {
      width: 24px;
      height: 24px;
    }

    ${TileHyperLinkText} {
      ${ComponentMStyling(ComponentTextStyle.Bold, null)}
    }

    a {
      gap: 6px;
    }
  }

  &.large {
    ${TileHyperLinkIcon} {
      width: 28px;
      height: 28px;
    }

    ${TileHyperLinkText} {
      ${ComponentLStyling(ComponentTextStyle.Bold, null)}
    }

    a {
      gap: 8px;
    }
  }
`

export const RenderTileItem = (item: TileIconButton | TileToggleButton | TileDropdownButton | TileTextDropdownButton | TileStandardButton | TileNote | TileHyperLink,
                               size: Size,
                               key: any | undefined = undefined) => {
  switch (item.componentType) {
    case 'icon': {
      return <IconButton key={key}
                         variant={item.variant ?? 'secondary'}
                         useTransparentBackground={item.variant == 'secondary' ? true : false}
                         shape={item.shape ?? 'circular'}
                         action={item.action}
                         tooltip={item.tooltip}
                         disabled={item.disabled}>
        {item.icon}
      </IconButton>
    }
    case 'toggle': {
      return <ToggleButton key={key}
                           active={item.active}
                           onChange={item.onChange}
                           defaultState={item.defaultState}
                           activeState={item.activeState}
                           disabled={item.disabled}/>
    }
    case 'dropdown': {
      return <DropdownButton key={key}
                             type={'icon'}
                             items={item.items}
                             itemsType={item.itemsType}
                             onClick={item.onClick}
                             value={item.value}
                             icon={item.icon}
                             tooltip={item.tooltip}
                             action={item.action}
                             actionIcon={item.actionIcon}
                             actionLabel={item.actionLabel}
                             actionVariant={item.actionVariant}
                             actionLoading={item.actionLoading}
                             multiSelect={item.multiSelect}
                             scrollable={item.scrollable}
                             pinTopItem={item.pinTopItem}
                             maxHeight={item.maxHeight}
                             disabled={item.disabled}/>

    }
    case 'text-dropdown': {
      return <DropdownButton key={key}
                             type={'text'}
                             items={item.items}
                             itemsType={item.itemsType}
                             onClick={item.onClick}
                             value={item.value}
                             label={item.label}
                             keepLabel={item.keepLabel}
                             action={item.action}
                             actionIcon={item.actionIcon}
                             actionLabel={item.actionLabel}
                             actionVariant={item.actionVariant}
                             actionLoading={item.actionLoading}
                             multiSelect={item.multiSelect}
                             scrollable={item.scrollable}
                             pinTopItem={item.pinTopItem}
                             maxHeight={item.maxHeight}
                             disabled={item.disabled}/>

    }
    case 'note': {
      return (
        <TileNoteWrapper key={key} className={size}>
          {
            item.noteIcon &&
            <TileNoteIcon>
              {React.cloneElement(item.noteIcon as React.ReactElement<any>, {size: size === Size.Large ? '20px' : '16'})}
            </TileNoteIcon>
          }
          <TileNoteText>{item.noteText}</TileNoteText>
        </TileNoteWrapper>
      );

    }
    case 'link': {
      const {linkText, componentType, linkIcon, ...rest} = item;
      return (
        <TileHyperLinkWrapper className={size} key={key}>
          <HyperLink {...rest}>
            <TileHyperLinkText>{linkText}</TileHyperLinkText>
            {
              linkIcon &&
              <TileHyperLinkIcon>
                {React.cloneElement(linkIcon as React.ReactElement<any>, {size: size === Size.Large ? '28px' : '24px'})}
              </TileHyperLinkIcon>
            }
          </HyperLink>
        </TileHyperLinkWrapper>
      );
    }
    case 'button': {
      const {buttonText, componentType, ...rest} = item;
      return <TextButton key={key}
                     size={[Size.XSmall, Size.XSmall, Size.XXSmall].includes(size) ? Size.Small: 
                      size == Size.Large ? Size.Large : Size.Medium}
                     {...rest}>
        {buttonText}
      </TextButton>
    }
  }
}
